"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfferPromotionActiveStatus = getOfferPromotionActiveStatus;
const dayjs_1 = __importDefault(require("dayjs"));
// when passing array, offerId must be provided too
// returns true if promotion status is active, otherwise false
function getOfferPromotionActiveStatus(offerPromotions, offerId) {
    if (!offerPromotions) {
        return false;
    }
    const checkBetweenDate = (startDate, endDate) => {
        return (0, dayjs_1.default)().isBetween(startDate, endDate, 'day', '[]');
    };
    if (!Array.isArray(offerPromotions)) {
        return checkBetweenDate(offerPromotions.startDate, offerPromotions.endDate);
    }
    const filteredOfferPromotions = offerPromotions.filter(op => {
        if (op.offerId === offerId && (0, dayjs_1.default)(op.endDate).isSameOrAfter((0, dayjs_1.default)())) {
            return true;
        }
        return false;
    });
    return filteredOfferPromotions.some(op => checkBetweenDate(op.startDate, op.endDate));
}
